import { get } from '../api';

const route = '/auth/validate_token';

const getCurrentUser = (config) => get(route, config);

export default getCurrentUser;
